import { type QueryClient } from '@tanstack/react-query';
import pino from 'pino';

import { composites } from '../../../../common/constants/access';
import { getVerifyUserAccessQuery, userQuery } from '../../../queries/userQuery';
import { virtualCardTask, walletDetailsQuery } from '../../../queries/walletQuery';
import { useZustand } from '../../../zustandStore';

const logger = pino();

type WalletDetailsRouteParams = {
	taskId: string;
	virtualCardId: string;
};

export const walletDetailsLoader = async ({
	queryClient,
	params,
}: {
	queryClient: QueryClient;
	params: WalletDetailsRouteParams;
}) => {
	const verifyUserAccessQuery = getVerifyUserAccessQuery((composites as any).WRITE_COMPANY);
	const userData = await queryClient.ensureQueryData(userQuery);

	const hasAccess = await queryClient.ensureQueryData({
		queryKey: verifyUserAccessQuery.queryKey,
		queryFn: verifyUserAccessQuery.queryFn,
	});

	let walletData;

	if (params.virtualCardId) {
		try {
			walletData = await queryClient.ensureQueryData(virtualCardTask(params.virtualCardId));
		} catch (error) {
			logger.error(error);
			walletData = undefined;
		}
	} else if (params.taskId) {
		try {
			walletData = await queryClient.ensureQueryData(walletDetailsQuery(params.taskId));
		} catch (error) {
			logger.error(error);
			walletData = undefined;
		}
	}
	const isCardOwner = walletData?.context?.request?.requester?.userId === userData?.userId;

	useZustand.getState().setPageLoading(false);

	return {
		userData,
		hasAccess,
		requestTitle: walletData?.request?.title,
		isCardOwner,
	};
};
